/**
 * @desc 支付结果中转页
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** merchantNo */
  merchantNo?: string
  /** merchantTradeNo */
  merchantTradeNo?: string
  /** sign */
  sign?: string
  /** timestamp */
  timestamp?: string
  /** transactionId */
  transactionId?: number
}

export const init = undefined

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/paymentResultForward',
    data: params,
    method: 'head',
  })
}
